interface PortionMarkProps {
  classification: string | undefined
  disseminationControls?: string[]
  className?: string
}

export function PortionMark({ classification, disseminationControls, className }: PortionMarkProps) {
  if (!classification) return null
  const text = [classification, ...(disseminationControls ?? [])].join('//')
  return (
    <span className={`mr-1 type-portion-mark text-fg-secondary ${className ?? ''}`}>
      ({text})
    </span>
  )
}
